module.exports = __webpack_public_path__ + "static/media/default-profile.81ad2987.svg";